import { lastActiveLabel } from "../../utils/timeFormat";

// Live presence.
//
// The green dot means "this person is online RIGHT NOW" and is only ever
// rendered from real data — never decoratively. The old screens painted it on
// every avatar unconditionally, which made it meaningless.
//
// BACKEND DEPENDENCY: get-chat-list / get-chat-detail do not return a presence
// field yet. Until they do, `isOnline` is false for everyone, so no green dot
// and no "Active now" renders — which is the correct failure mode (silence
// rather than a lie). These readers accept the field names the API is most
// likely to use so the dot lights up the moment one of them ships.
export function isOnline(user) {
  if (!user) return false;
  const raw =
    user.is_online ?? user.online ?? user.is_active ?? user.presence ?? null;
  if (raw == null) return false;
  if (typeof raw === "boolean") return raw;
  if (typeof raw === "number") return raw === 1;
  const s = String(raw).toLowerCase();
  return s === "1" || s === "true" || s === "online" || s === "active";
}

export function lastActiveAt(user) {
  return (
    user?.last_active_at ?? user?.last_seen_at ?? user?.last_active ?? null
  );
}

// "Active now" when online, "Last active Jul 14" when we know when they were,
// and null when we know neither — the caller then renders no status line at all
// rather than inventing one.
export function statusLine(user, now = new Date()) {
  if (isOnline(user)) return "Active now";
  return lastActiveLabel(lastActiveAt(user), now);
}
